import { render } from "./SmsAccount.vue?vue&type=template&id=660b29cd&scoped=true"
import script from "./SmsAccount.vue?vue&type=script&lang=js"
export * from "./SmsAccount.vue?vue&type=script&lang=js"

import "./SmsAccount.vue?vue&type=style&index=0&id=660b29cd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660b29cd"]])

export default __exports__